import templateStr from 'text!./templates/billing-summary-actions.html';

export default (function () {
    return {
        template: templateStr,
        transclude: true,
        scope: {
            paymentSourceAction: '=',
            paymentAction: '=',
            automaticAction: '=',
            viewAction: '='
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/billing/directives/BillingSummaryActions.js
// module id = 1402
// module chunks = 0